import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString } from "vue"

import { ref, watch, onMounted } from 'vue';

interface Props {
  value: number;
  duration?: number; // ms
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedNumber',
  props: {
    value: {},
    duration: { default: 800 }
  },
  setup(__props: any) {

const props = __props;

const displayed = ref(0);
let rafId: number | null = null;

const animateTo = (target: number) => {
  if (rafId !== null) cancelAnimationFrame(rafId);
  const start = displayed.value;
  const delta = target - start;
  if (delta === 0) return;
  const startTime = performance.now();
  const tick = (now: number) => {
    const t = Math.min((now - startTime) / props.duration, 1);
    // ease-out cubic — quick at first, slows as it approaches
    const eased = 1 - Math.pow(1 - t, 3);
    displayed.value = Math.round(start + delta * eased);
    if (t < 1) {
      rafId = requestAnimationFrame(tick);
    } else {
      rafId = null;
    }
  };
  rafId = requestAnimationFrame(tick);
};

onMounted(() => animateTo(props.value));

watch(() => props.value, (newVal) => animateTo(newVal));

return (_ctx: any,_cache: any) => {
  return _toDisplayString(displayed.value.toLocaleString())
}
}

})